import _ from 'lodash';
import {
    FETCH_MTOKNA_CONTACTS,
    CLEAN_MTOKNA_CONTACTS,
    DELETE_MTOKNA_CONTACT,
    UNSUBSCRIBE_MTOKNA_CONTACT,
    SUBSCRIBE_MTOKNA_CONTACT,
    SEND_CONTACTS,
} from './types';
import {request, __} from '../functions';

export const fetchMtoknaContacts = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
        callback: null,
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/mtokna/contacts', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        if (options.callback !== null) {
            // Zavolame callback
            options.callback();
        }

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_MTOKNA_CONTACTS, payload: data });
    });
};

export const cleanMtoknaContacts = () => ({ type: CLEAN_MTOKNA_CONTACTS });

export const deleteMtoknaContact = (screen, id) => {
    return dispatch => request(`/mtokna/removeContact/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Email sa nepodarilo zmazať'));
            return;
        }

        screen.showSnackbar('success', __('Email bol zmazaný'));

        dispatch({ type: DELETE_MTOKNA_CONTACT });
    });
};

export const unsubscribeMtoknaContact = (screen, email) => {
    return dispatch => request(`/mtokna/unsubscribeContact/${email}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Email sa nepodarilo odhlásiť'));
            return;
        }

        screen.showSnackbar('success', __('Email bol odhlásený'));

        dispatch({ type: UNSUBSCRIBE_MTOKNA_CONTACT, payload: email });
    });
};

export const subscribeMtoknaContact = (screen, email) => {
    return dispatch => request(`/mtokna/subscribeContact/${email}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Email sa nepodarilo prihlásiť'));
            return;
        }

        screen.showSnackbar('success', __('Email bol prihlásený'));

        dispatch({ type: SUBSCRIBE_MTOKNA_CONTACT, payload: email });
    });
};

export const sendContacts = (screen, ids, mtokna_campaign_id, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/mtokna/multiSendContacts/${ids}/${mtokna_campaign_id}`, params).then(response => {
        const { status, data } = response.data;

        if (status === 'error') {
            // Stav sa nepodarilo zmenit
            screen.showSnackbar('error', __('Kampaň sa nepodarilo odoslať'));
            return;
        }

        screen.showSnackbar('success', __('Kampaň bola odoslaná'));

        dispatch({ type: SEND_CONTACTS, payload: data });
    });
};
